import { createFileRoute, Navigate } from '@tanstack/react-router'

export const Route = createFileRoute('/(redirects)/bak/pending-subscriptions/')({
  component: () => <Navigate replace search to="/bo/subscriptions" />,
})
